// import productRoutes from '@/store.product/routes';

export default [
  {
    path: "/:catalog",
    name: "catalog",
    component: () => import("./components/main-view.vue"),
    props: true,
    meta: {
      title: "OneBuy"
    },
    //children: productRoutes
  },
  {
    path: "/search/query=:query",
    name: "search",
    component: () => import("./components/main-view.vue"),
    props: true,
    meta: {
      title: "Search",
      isSearchPage: true
    },
    //children: productRoutes
  }
];
